import {useQuery} from 'react-query'
import {getMyNavigation} from './_requests'
import {FeatureNode} from './_models'

export const useNavigationMenu = (enabled: boolean) => {
  const {data, isLoading, isError} = useQuery<FeatureNode[]>(
    'my-navigation',
    () => getMyNavigation(),
    {
      enabled,
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: true,
      retry: 1,
    }
  )

  return {navigation: data, isLoading, isError}
}
